import { createContext, useCallback, useContext, useMemo, useState } from "react";

const AppModalContext = createContext(null);

export function AppModalProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [trigger, setTrigger] = useState(null); // where the modal was triggered from

  const openModal = useCallback((from = "unknown") => {
    setTrigger(from);
    setOpen(true);
  }, []);
  const closeModal = useCallback(() => setOpen(false), []);

  const value = useMemo(
    () => ({ open, trigger, openModal, closeModal, setOpen }),
    [open, trigger, openModal, closeModal],
  );

  return <AppModalContext.Provider value={value}>{children}</AppModalContext.Provider>;
}

export function useAppModal() {
  const ctx = useContext(AppModalContext);
  if (!ctx) throw new Error("useAppModal must be used inside <AppModalProvider>");
  return ctx;
}
